<template>
  <div>
    <div class="main-wrapper">
      <div>
        <layout-header></layout-header>
        <breadcrumb43></breadcrumb43>
        <!-- Page Content -->
        <div class="content">
          <div class="container">
            <div class="row">
              <!-- Profile Sidebar -->
              <div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                <sidebar1></sidebar1>
              </div>
              <div class="col-md-7 col-lg-8 col-xl-9" v-if="showspinner">
                <loader></loader>
              </div>
              <!-- / Profile Sidebar -->
              <div class="col-md-7 col-lg-8 col-xl-9" v-else>

                <div class="card ml-md-4 mt-1" style="border: none;">
                  <div class="card-header">
                    <div class="row">
                      <div class="col-sm-12" style="margin-top: -15px;">
                        <div class="text-left">
                          <a href="#" data-toggle="modal" data-target="#graph4" class="btn btn-primary"
                            tabindex="0" @click="AddDependent()">Add Dependent</a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="card-body">
                    <!-- Dependent Tab -->
                    <div class="card card-table mb-0" style="border: none;">
                      <div class="card-body">
                        <div class="table-responsive">
                          <table class="table table-hover table-center mb-0">
                            <thead>
                              <tr>
                                <th style="text-align: left;">Dependent</th>
                                <th style="text-align: left;">Relation</th>
                                <th style="text-align: left;">Mobile Number</th>
                                <th style="text-align: left;">Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(item, index) in dependent" v-bind:key="index" v-show="setPaginate(index)">
                                <td>
                                  <h2 class="table-avatar">
                                    {{ item.relative_name }}
                                  </h2>
                                </td>
                                <td>
                                  {{ item.relation ? item.relation : "-" }}
                                </td>
                                <td>{{ item.mobile ? item.mobile : "-" }}</td>
                                <td>
                                  <div class="table-action">
                                    <a href="#graph4" class="btn btn-sm bg-info-light" data-toggle="modal"
                                      @click="editDependent(item)">
                                      <i class="fas fa-edit"></i> Edit</a>
                                    <a href="javascript:void(0);" class="btn btn-sm bg-danger-light"
                                      @click="delete_dependent(item.name, item.relative_name)"><i class="fas fa-times"></i> Delete</a>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <h5 v-if="dependent.length === 0 && !showspinner" style="margin-left: -8%" class="No_data">
                          No Dependent Found
                        </h5>
                        <!-- pagination start -->
                        <div id="pagination" v-if="dependent.length > 10">
                          <ul class="pagination justify-content-center">

                            <!-- "Previous" Button -->
                            <li class="page-item" :class="current === 1 ? 'disabled' : ''">
                              <a href="#" class="page-link" aria-label="Previous"
                                @click.prevent="updateInvestigationCount(current - 1)">
                                Previous
                              </a>
                            </li>

                            <!-- Pagination Links (Display 5 at a time) -->
                            <li v-for="page_index in paginate_total" :key="page_index.id" :class="[
                              'page-item',
                              current === page_index ? 'active' : ''
                            ]" v-if="page_index >= current - 2 && page_index <= current + 2">
                              <a href="#" class="page-link" @click.prevent="updateInvestigationCount(page_index)">
                                {{ page_index }}
                              </a>
                            </li>

                            <!-- "Next" Button -->
                            <li class="page-item" :class="current === paginate_total ? 'disabled' : ''
                              ">
                              <a href="#" class="page-link" aria-label="Next"
                                @click.prevent="updateInvestigationCount(current + 1)">
                                Next
                              </a>
                            </li>
                          </ul>
                        </div>
                        <!-- pagination end -->
                      </div>
                    </div>
                    <!-- /Dependent Tab -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /Page Content -->
        <layout-footer></layout-footer>
      </div>
    </div>
    <div class="modal fade custom-modal show" id="graph4">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              {{
                patient_dependent.name ? "Update Dependent" : "Add Dependent"
              }}
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="card">
              <div class="card-body">
                <div class="row form-row">
                  <div class="col-12 col-md-12">
                    <div class="form-group">
                      <label>Relative Name <span class="No_data">*</span></label>
                      <input v-model="patient_dependent.relative_name" type="text" class="form-control" value=""
                        @input="onInput" />
                    </div>
                  </div>
                  <div class="col-12 col-md-12">
                    <div class="form-group">
                      <label>Relationship</label>
                      <v-select class="mr-2" required="" placeholder="select relationship"
                        v-model="patient_dependent.relation" :options="relationship">
                      </v-select>
                    </div>
                  </div>
                  <div class="col-12 col-md-12">
                    <div class="form-group">
                      <label>Description</label>
                      <input v-model="patient_dependent.description" type="text" class="form-control" value="" />
                    </div>
                  </div>
                  <div class="col-12 col-md-12">
                    <div class="form-group">
                      <label>Mobile Number</label>
                      <input v-model="patient_dependent.mobile" type="text" class="form-control" value=""
                        oninput="this.value = this.value.replace(/[^0-9]/g, '');" minlength="10" maxlength="10" />
                    </div>
                  </div>
                </div>
                <div class="submit-section" style="text-align: left">
                  <button :disabled="disabled" @click="add_dependent()" class="btn btn-primary submit-btn"
                    data-dismiss="modal" aria-label="Close">
                    Save Changes
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import CommonApi from "../../../services/CommonApi";
export default {
  data() {
    return {
      dependent: [],
      existing_dependent: [],
      showspinner: true,
      editdependent: false,
      relationship: [],
      disabled: true,
      patient_dependent: {
        name: "",
        relative_name: "",
        relation: "",
        description: "",
        mobile: "",
      },
      current: 1,
      paginate: 10,
      paginate_total: 0,
    };
  },
  computed: {
    ...mapState({
      user_id: (state) => state.user.user_id,
    }),
    relative_name() {
      return this.patient_dependent.relative_name;
    },
  },
  watch: {
    relative_name() {
      if (this.patient_dependent.relative_name === "") {
        this.disabled = true;
      } else {
        this.disabled = false;
      }
    },
  },
  mounted() {
    let user = localStorage.getItem("userInfo");
    if(!user){
      this.$router.push({name:'login'})
    }
    this.get_patient_dependant();
    this.get_relationship();
  },
  methods: {


    //pagination start
    updateInvestigationCount(i) {
      this.current = i;
      document.getElementById("patient_container").scrollIntoView();
    },

    setPaginate(i) {
      if (this.current == 1) {
        return i < this.paginate;
      } else {
        return (
          i >= this.paginate * (this.current - 1) &&
          i < this.current * this.paginate
        );
      }
    },
    //pagination end


    onInput(event) {
      let inputValue = event.target.value;
      let lettersOnly = inputValue.replace(/[^a-z A-Z]/g, "");
      this.patient_dependent.relative_name = lettersOnly;
    },

    /* Edit Dependent  */
    editDependent(data) {
      (this.editdependent = true),
        (this.patient_dependent.name = data.name),
        (this.patient_dependent.relative_name = data.relative_name),
        (this.patient_dependent.relation = data.relation),
        (this.patient_dependent.description = data.description),
        (this.patient_dependent.mobile = data.mobile);
    },

    AddDependent() {
      (this.editdependent = false),
        (this.patient_dependent.name = ""),
        (this.patient_dependent.relative_name = ""),
        (this.patient_dependent.relation = ""),
        (this.patient_dependent.description = ""),
        (this.patient_dependent.mobile = "");
    },

    /* Get Dependent  */
    async get_patient_dependant() {
      const params = new URLSearchParams();
      params.append("parent", this.user_id);
      await CommonApi.get_data("sahaj.api.get_patient_dependant", params).then(
        (res) => {
          this.showspinner = false;
          if (res && res.data) {
            this.dependent = res.data;
            this.paginate_total = Math.ceil(
              this.dependent.length / this.paginate
            );
            res.data.map((data) => {
              this.existing_dependent.push({
                name: data.name,
                relative_name: data.relative_name,
                relation: data.relation,
                description: data.description,
                mobile: data.mobile,
              });
            });
          }
        }
      );
    },

    /* Get Dependent  */
    async get_relationship() {
      await CommonApi.get_data("sahaj.api.get_relationship").then((res) => {
        this.showspinner = false;
        if (res && res.message) {
          this.relationship = res.message;
        }
      });
    },

    /* Add Dependent  */
    async add_dependent() {
        this.$swal({
          text: "Adding Dependent...",
          showConfirmButton: false,
          allowOutsideClick: false,
          didOpen: () => {
            this.$swal.showLoading();
          },
        });
        var data = new FormData();
        let patient_name = {
          name: this.user_id,
        };
        if (this.editdependent) {
          let objIndex = this.existing_dependent.findIndex(
            (obj) => obj.name === this.patient_dependent.name
          );
          this.existing_dependent[
            objIndex
          ].relative_name = this.patient_dependent.relative_name;
          this.existing_dependent[
            objIndex
          ].relation = this.patient_dependent.relation;
          this.existing_dependent[
            objIndex
          ].description = this.patient_dependent.description;
          this.existing_dependent[
            objIndex
          ].mobile = this.patient_dependent.mobile;
        } else {
          this.existing_dependent.push(this.patient_dependent);
        }

        this.existing_dependent = this.existing_dependent.map(
          ({ name, ...rest }) => ({ ...rest })
        );
        data.append("patient", JSON.stringify(patient_name));
        data.append("dependent_list", JSON.stringify(this.existing_dependent));
        await CommonApi.post_data(
          "sahaj.api.update_patient_dependent",
          data
        ).then((res) => {
          this.showspinner = false;
          if (res && res.status_code === 200) {
            this.$swal.fire({
              icon: "success",
              title: "Success",
              text: res.message,
              showConfirmButton: true,
            });
            this.get_patient_dependant();
            this.editdependent = false;
            this.$emit("close");
          } else {
            this.$swal.fire({
              icon: "warning",
              title: "Warning",
              text: res.message,
              showConfirmButton: true,
            });
          }
          this.existing_dependent = [];
          this.patient_dependent.relative_name = "";
          this.patient_dependent.relation = "";
          this.patient_dependent.description = "";
          this.patient_dependent.mobile = "";
        });
      
    },

    /* Cancel Appointment */
    delete_dependent(id, name) {
      this.$swal
        .fire({
          title: "Delete Dependent",
          text: `Are you sure you want to remove ${name} as a family member?`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel",
          cancelButtonColor: "#d33",
        })
        .then((result) => {
          if (result.value) {
            this.$swal({
              text: "Removing Dependent...",
              showConfirmButton: false,
              allowOutsideClick: false,
              didOpen: () => {
                this.$swal.showLoading();
              },
            });
            let data = {
              name: id,
            };
            CommonApi.post_data(
              "sahaj.api.delete_patient_dependent",
              data
            ).then((res) => {
              if (res) {
                this.$swal.fire({
                  icon: "success",
                  title: "Success",
                  text: res.message,
                  showConfirmButton: true,
                });
                this.get_patient_dependant();
              } else {
                this.$swal.fire({
                  icon: "error",
                  title: "Error",
                  text: res.message,
                  showConfirmButton: true,
                });
              }
            });
          }
        });
    },
  },
};
</script>
<style scoped>
table {
    border-collapse: collapse;
    width: 100%;
    border-top: 1px solid #dddddd; /* Add an upper border */
  }

  th, td {
    border: 1px solid #dddddd; /* You can adjust the border width and color as needed */
    padding: 8px;
    text-align: left;
  }

  th {
    background-color: #F8F8F8;
  }
</style>


// WEBPACK FOOTER //
// src/components/kneexpert/patient/Dependent.vue